<template>
  <div
    class="content-pane"
    :dir="participantDocumentDirection || undefined"
    :lang="participantHtmlLang || undefined"
  >
    <slot />
  </div>
</template>

<script>
import participantDocumentDirection from '~/mixins/participantDocumentDirection';

export default {
  mixins: [participantDocumentDirection],
};
</script>
